import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import useOpenModal from '../../../hooks/useOpenModal';
import appConfig from '../../../appConfig';

const isUS = appConfig.regions.isUS;

const AccountMenu = () => {
	const handleOpenModal = useOpenModal();

	return (
		<AccountMenuContainer>
			<AccountMenuLinkItem to="/account/profile" $isLeft={true} activeStyle={activeStyle} exact>
				Profile
			</AccountMenuLinkItem>
			<AccountMenuButtonItem onClick={() => handleOpenModal('deposit')}>Deposit</AccountMenuButtonItem>
			<AccountMenuLinkItem to="/account/withdraw" activeStyle={activeStyle} exact>
				Withdraw
			</AccountMenuLinkItem>
			<AccountMenuLinkItem to="/account/transactions" activeStyle={activeStyle} exact>
				Cash Transactions
			</AccountMenuLinkItem>
			<AccountMenuLinkItem to="/account/limits" activeStyle={activeStyle} exact>
				Limits
			</AccountMenuLinkItem>
			{!isUS && (
				<AccountMenuLinkItem to="/account/take-a-break" activeStyle={activeStyle} exact>
					Take a break
				</AccountMenuLinkItem>
			)}
			{isUS && (
				<AccountMenuLinkItem to="/account/timeout" activeStyle={activeStyle} exact>
					Timeout
				</AccountMenuLinkItem>
			)}
			<AccountMenuLinkItem to="/account/self-exclusion" activeStyle={activeStyle} exact>
				Self Exclusion
			</AccountMenuLinkItem>
			<AccountMenuLinkItem to="/account/close-account" $isRight={true} activeStyle={activeStyle} exact>
				Close Account
			</AccountMenuLinkItem>
		</AccountMenuContainer>
	);
};

export default AccountMenu;

const activeStyle = {
	backgroundColor: '#4A4D50',
};

const AccountMenuContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: 55px;
	border-radius: 5px;
	font-size: 18px;
	color: #ffffff;
	background-color: #2d3134;
`;

const AccountMenuLinkItem = styled(NavLink)<{ $isLeft?: boolean; $isRight?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	flex-grow: 1;

	${({ $isLeft }) => $isLeft && 'border-top-left-radius: 5px; border-bottom-left-radius: 5px; '};
	${({ $isRight }) => $isRight && 'border-top-right-radius: 5px; border-bottom-right-radius: 5px; '};

	&: hover {
		background-color: '#4A4D50';
	}
`;

const AccountMenuButtonItem = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	flex-grow: 1;

	&:focus {
		outline: none;
	}

	&: hover {
		background-color: '#4A4D50';
	}
`;
